module.exports = __webpack_public_path__ + "820f7ac62bb5782c45d58d3f1ae45aee.svg";